import {Suspense, useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {Outlet} from 'react-router-dom'
import { axiosConfig } from 'utils/axiosConfig'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import { chengeNotifications } from './reduxStore/Global/GlobalActions'
import { useTranslation } from 'react-i18next'
import './App.css'
import { Notification } from './Notification'
// import './FirebaseConfig.js'

const App = () => {
  const dispatch = useDispatch()
  const selector = useSelector((state:any)=>state?.GlobalReducer)
  const {t}= useTranslation()
  function getAllNotifications(){
    axiosConfig.get(`/admin-notifications/all-notifications`,{
      headers: {
          "Authorization": `Bearer ${localStorage.getItem('token')}`,
      }
  }).then(res=>{
        dispatch(chengeNotifications(res.data?.data?.data))
    }).catch(err=>{
        console.log(err)
    })
}
  useEffect(()=>{
    getAllNotifications()
  },[])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          {/* <AuthInit> */}
          <Notification/>
          {
            ((selector?.receivingOrdersStatus ==2) && selector?.userData?.user_type=='provider')&&
            <div className='notify'>{t('Receiving Orders Is Disabled')}</div>
          }
            <Outlet />
            <MasterInit />
          {/* </AuthInit> */}
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
